export default {
  notification: '通知',
  yes: 'Yes',
  no: 'No',
  male: '男性',
  female: '女性',
}
